import React from 'react'

// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
// actions
import * as USER_ACTION from '@store/user/actions'
import * as SHARED_ACTION from '@store/shared/actions'

import { Modal, Icon } from '@components/shared/elements'
import MaskedInput from 'react-text-mask'

import TOOLS from '@helpers/tools'
import COOKIES from '@helpers/cookies'
import slugify from 'slugify'
import { isEqual, isEmpty } from 'lodash'

import { genericModalDataLayer } from '@helpers/BI'

class ModalWhatsapp extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      phone: '',
      // financiamento: false,
      shBranchId: '',
      stateInitials: '',
      nameDirt: false,
      phoneDirt: false,
      typeContactDirt: false,
      blockSending: false,
      success: '',
      error: '',
      hasBranches: false,
      branchSelected: '',
      hasFacilitaMsg: '',
      privacyPolicies: true,
      hasListaFiliais: false,
      singleFilial: false,
      listaFiliaisAtendimento: [],
    }
    this.el = React.createRef()
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.region !== this.props.region) {
      let stateList = this.props.regions
      let praca
      if (stateList.success) {
        let busca = await stateList.estados.find(item => item.IdEstado === this.props.region)
        praca = busca.Uf.toLowerCase()
        this.setState({
          stateInitials: `${praca}`,
        })
      }
    }

    if (prevState.blockSending !== this.state.blockSending) {
      setTimeout(() => {
        this.setState({
          name: '',
          phone: '',
          email: '',
          // financiamento: false,
          shBranchId: '',
          stateInitials: '',
          nameDirt: false,
          phoneDirt: false,
          typeContactDirt: false,
          blockSending: false,
          success: false,
          error: false,
          errorMsg: '',
          hasBranches: false,
          branchSelected: '',
          hasFacilitaMsg: '',
          privacyPolicies: true,
        })
      }, 3000)
    }

    const listaFiliaisAtendimento = this.props.branches.listaFiliaisAtendimento
    if (!isEqual(prevState.listaFiliaisAtendimento, listaFiliaisAtendimento)) {
      this.setState({
        listaFiliaisAtendimento: listaFiliaisAtendimento,
        hasListaFiliais: !isEmpty(listaFiliaisAtendimento),
      })
      if (this.state.hasListaFiliais) {
        if (listaFiliaisAtendimento.length === 1) {
          this.setState({ singleFilial: true })
          const item = listaFiliaisAtendimento[0]
          if (this.state.shBranchId !== item.CodigoFilial) {
            this._handleChangeBranch(item)
          }
        } else {
          this.setState({ singleFilial: false })
        }
      }
    }

    if (prevState.shBranchId !== this.state.shBranchId) {
      let dadosFilial = listaFiliaisAtendimento.find(item => item.CodigoFilial === this.state.shBranchId)
      if (!isEmpty(dadosFilial)) {
        if (this.state.shBranchModalId !== dadosFilial.CodigoIntegracaoWhatsapp) {
          if (this.props.product.success) {
            this.setState({
              shBranchModalId: dadosFilial.CodigoIntegracaoWhatsapp + '-ficha-imovel',
              shBranchName: dadosFilial.Nome,
            })
          } else {
            this.setState({
              shBranchModalId: dadosFilial.CodigoIntegracaoWhatsapp,
              shBranchName: dadosFilial.Nome,
            })

          }
        }
      }
    }
  }

  _toggleMenu(event) {
    event.preventDefault()
    this.setState({
      showMenuChat: !this.state.showMenuChat,
    })
  }

  handleBranchSelect = async selectedBranch => {
    await this.setState({ branch: selectedBranch })
  }

  _handleChangeBranch(item) {
    this.setState({ branchSelected: item.Nome, shBranchId: item.CodigoFilial })
    if (this.props.product.success) {
      this.setState({
        shBranchModalId: `${this.props.branches.CodigoPadraoIntegracaoWhatsapp}-ficha-imovel`,
      })
    } else {
      this.setState({
        shBranchModalId: item.CodigoIntegracaoWhatsapp,
      })
    }
  }

  async _enviaMensagem(element) {
    this.setState({ nameDirt: true, phoneDirt: true, blockSending: true })

    let nome = this.state.name
    let phoneValid = (TOOLS.phoneValid(this.state.phone))
    if (nome !== '' && phoneValid) {
      this.setState({ nameDirt: false, phoneDirt: false, blockSending: true })

      let region = this.props.region === undefined
        ? this.props.product.imovel.Localizacao.IdEstado
        : this.props.region

      let values = {
        email: this.state.email,
        nome: this.state.name,
        telefone: this.state.phone,
        filial: this.state.shBranchId,
        whatsApp: this.state.whatsapp,
        praca: this.state.stateInitials,
        product: this.props.product.imovel,
        highlight: this.props.highlightModal,
        gaSend: COOKIES.getUtmGaSend(),
        regionId: parseInt(region, 10),
        idLogFacilita: null,
      }

      // SP
      if (values.regionId === 1) {
        if (this.state.shBranchId === 3322) { // ????????????
          let urlWithoutQuerystring = window.location.href.split('?')[0]

          let dadosFilial = this.props.branches.listaFiliaisAtendimento.find(item => item.CodigoFilial === this.state.shBranchId)

          let nomeCidade = this.props.locations.find(item => item.idEstado === this.props.region)

          let jsonBody = {}
          jsonBody['facilita_custom_page'] = document.title
          jsonBody['facilita_custom_url'] = `${urlWithoutQuerystring}?utm_campaign=${values.gaSend.UtmCampaign}&utm_content=${values.gaSend.UtmContent}&utm_medium=${values.gaSend.UtmMedium}&utm_source=${values.gaSend.UtmSource}&utm_term=${values.gaSend.UtmTerm}${!!values.gaSend.UtmGclid ? `&utm_gclid=${values.gaSend.UtmGclid}` : ''}`
          jsonBody['facilita_custom_selector'] = '#ModalWhatsapp'
          jsonBody['name'] = this.state.name
          jsonBody['phone'] = this.state.phone
          jsonBody['codigo_filial'] = dadosFilial.CodigoFilial
          jsonBody['nome_filial'] = dadosFilial.Nome
          jsonBody['client_id_ga'] = values.gaSend.CodigoGa
          jsonBody['idImovel'] = undefined
          jsonBody['empreendimento'] = undefined
          jsonBody['cidade'] = nomeCidade.nome
          jsonBody['ImovelOrigemId'] = 3
          jsonBody['url'] = window.location.href
          jsonBody['CodigoGA'] = values.gaSend.CodigoGa
          jsonBody['EstadoId'] = values.regionId
          jsonBody['produto'] = 31

          if (values.product && values.product.imovelId) {
            jsonBody['idImovel'] = values.product.imovelId
            jsonBody['produto'] = values.product.IdFacilita || 31
            jsonBody['empreendimento'] = values.product.Nome
            jsonBody['cidade'] = values.product.Localizacao.Cidade
          }

          if (values.highlight && values.highlight.imovelId) {
            jsonBody['idImovel'] = values.highlight.imovelId
            jsonBody['produto'] = values.highlight.idFacilita || 31
            jsonBody['empreendimento'] = values.highlight.imovelNome
            jsonBody['cidade'] = values.highlight.imovelLocalizacao
          }

          let logPayload = {
            IdImovelOrigem: 3,
            PontoContato: 10,
            IdentificadorLog: 'E028', //codigo padrão - falha facilita
          }
          this.props.actions.callFacilita(jsonBody).then(responseFacilita => {
            logPayload['Descricao'] = `{ "request": ${JSON.stringify(jsonBody)}, "response": ${JSON.stringify(responseFacilita)} }`
            if (responseFacilita.status === 'success') {
              logPayload['IdentificadorLog'] = 'I023' // codigo - sucesso facilita
            }
          }).catch(erro => {
            logPayload['Descricao'] = `{ "request": ${JSON.stringify(jsonBody)}, "response": ${JSON.stringify(erro)} }`
          }).finally(() => {
            this.props.actions.recordLog(logPayload).then(response => {
              values['idLogFacilita'] = response.idLog
              this._generateLead(values)
            })
          })
        }
      } else {
        this._generateLead(values)
      }
    } else {
      this.setState({ blockSending: false })
    }

    // GA data
    const elementText = slugify(element.target.innerText, { lower: true })
    genericModalDataLayer(this.props.product.imovel, this.props.locations, this.props.region, 'modal-whatsapp', elementText)
  }

  _generateLead(values) {
    let jsonBody = {}
    jsonBody['Email'] = values.email
    jsonBody['EstadoId'] = values.regionId
    jsonBody['Nome'] = values.nome
    jsonBody['Telefone'] = values.telefone
    jsonBody['Filial'] = values.filial
    jsonBody['WhatsApp'] = values.whatsApp
    jsonBody['Praca'] = values.praca
    jsonBody['ImovelOrigemId'] = 3
    jsonBody['PontoContato'] = 'WhatsApp'
    jsonBody['url'] = window.location.href
    jsonBody['IdLog'] = values.idLogFacilita

    if (values.product && values.product.imovelId) {
      jsonBody['IdImovel'] = values.product.imovelId
      jsonBody['NomeImovel'] = values.product.Nome
      jsonBody['Cidade'] = values.product.Localizacao.Cidade
    }

    if (values.highlight && values.highlight.imovelId) {
      jsonBody['IdImovel'] = values.highlight.imovelId
      jsonBody['NomeImovel'] = values.highlight.imovelNome
      jsonBody['Cidade'] = values.highlight.imovelLocalizacao
    }

    Object.assign(jsonBody, values.gaSend)

    this.props.actions.contactUsWhatsapp(jsonBody).then((result) => {
      jsonBody.retorno = result.IdLead
      this.setState({
        nameDirt: false,
        phoneDirt: false,
        success: true,
      })
      setTimeout(() => { this.props.close() }, 3000)
    }).catch(result => {
      this.setState({ error: true, errorMsg: result.Msg })
      setTimeout(() => {
        this.setState({ error: false, errorMsg: '' }) }
      , 4000)
    }).finally(() => {
      this.setState({ nameDirt: false, blockSending: false })
    })
  }

  render() {
    let blockSending = this.state.blockSending
    let nameValid
    let phoneValid

    if (this.state.nameDirt) {
      nameValid = (this.state.name !== '') ? 'is-valid' : 'has-error'
    }

    if (this.state.phoneDirt) {
      phoneValid = (TOOLS.phoneValid(this.state.phone)) ? 'is-valid' : 'has-error'
    }

    const listaFiliaisAtendimento = this.state.listaFiliaisAtendimento
    const mostrarListaFiliais = this.state.hasListaFiliais && !this.state.singleFilial

    return <Modal show={this.props.show} close={this.props.close} fullscreen={false} goback={this.props.goback}>
      <h4 className='h5 mt3 mb2'><strong>Atendimento por Whatsapp</strong></h4>
      <form onSubmit={(event) => this._handleSubmit(event)} data-ga-name='modal-contato' id={this.state.shBranchId === 3322 ? 'modalwhatsapp' : ''}>

        <div className={`field-group mb2 ${nameValid === 'is-valid' && 'is-valid'} ${nameValid === 'has-error' && 'has-error'}`}>
          <label>
            <input className='mb0' type='text' value={this.state.name} onChange={(event) => this.setState({ name: event.target.value })} onBlur={() => this.setState({ nameDirt: true })} placeholder='Qual é seu nome?' maxLength='70' />
            <div className='text-small text-error ml1 mt1'>Qual seu nome?</div>
          </label>
          <span className='icon mr1'>
            <span className='field-icon'>
              <Icon iconType='far' icon='user' size='sm' />
            </span>
            <span className='text-error'>
              <Icon icon='times' size='sm' />
            </span>
            <span className='text-success'>
              <Icon icon='check' size='sm' />
            </span>
          </span>
        </div>
        <div className={`field-group mb3 ${phoneValid === 'is-valid' && 'is-valid'} ${phoneValid === 'has-error' && 'has-error'}`}>
          <label>
            <MaskedInput
              mask={TOOLS.cellphoneMask(this.state.phone)}
              guide={false}
              className='mb0'
              type='tel'
              value={this.state.phone}
              onChange={(event) => this.setState({ phone: event.target.value })}
              onBlur={() => this.setState({ phoneDirt: true })}
              placeholder='Qual é o seu telefone (com DDD)?'
            />
            <div className='text-small text-error ml1 mt1'>Seu telefone com DDD</div>
          </label>
          <span className='icon mr1'>
            <span className='field-icon'>
              <Icon icon='phone' size='sm' />
            </span>
            <span className='text-error'>
              <Icon icon='times' size='sm' />
            </span>
            <span className='text-success'>
              <Icon icon='check' size='sm' />
            </span>
          </span>
        </div>

        {mostrarListaFiliais &&
          <div className={'field-group mb3'}>
            <label>
              <div>
                <button className={`branchListButton ${this.state.showMenuChat ? 'active' : ''}`} onClick={(event) => this._toggleMenu(event)}>
                  <span>{this.state.branchSelected ? this.state.branchSelected : 'Selecione a loja mais próxima'}</span>
                </button>
                {this.state.showMenuChat &&
                  <ul className='branchList'>
                    {listaFiliaisAtendimento.map((item, index) => {
                      let siglaEstado = item.siglaEstado.toUpperCase()
                      return (
                        <li key={item.Id} className={this.state.branchSelected === item.Nome ? 'selecionado' : ''}>
                          <button
                            onClick={
                              (event) => {
                                this._toggleMenu(event)
                                this._handleChangeBranch(item)
                              }
                            }
                          >
                            <span className='icon hover hidden'>
                              <Icon icon='check' size='sm' />
                            </span>
                            <span><strong>{item.Nome}</strong></span>
                            <span>{item.Rua}, {item.Numero} - {item.nomeBairro}, {item.nomeCidade} - {siglaEstado}</span>
                          </button>
                        </li>
                      )
                    })}
                  </ul>
                }
              </div>
              <div className='text-small text-error ml1 mt1'>Preencha a loja mais próxima, por favor</div>
            </label>
            <span className='icon mr1'>
              <span className='field-icon'>
                <Icon icon='chevron-down' size='sm' />
              </span>
              <span className='text-error'>
                <Icon icon='times' size='sm' />
              </span>
              <span className='text-success'>
                <Icon icon='check' size='sm' />
              </span>
            </span>
          </div>
        }
        <div>
          <label htmlFor='privacy-field-newsletter'>Prezamos pela privacidade e a coleta dos seus dados pessoais atenderá as diretrizes da legislação aplicável. Para mais informações, acesse nosso{' '}
            <a href='/termos-privacidade' title='Aviso de Privacidade' target='_blank' rel='noreferrer noopener'>Aviso de Privacidade</a>
          </label>
        </div>

        <button className='button info min-width mt4' type='button' disabled={blockSending} onClick={e => this._enviaMensagem(e)} data-ga-status>{blockSending ? 'Enviando...' : 'Solicitar informações'}</button>

        {this.state.success &&
          <div className='callout success text-center mt4 mb0'>
            <p>Suas informações foram enviadas com sucesso.</p>
          </div>
        }
        {this.state.error &&
          <div className='callout alert text-center mt4 mb0'>
            <p>{this.state.errorMsg || 'Não foi possível realizar a sua solicitação, tente mais tarde.'}</p>
          </div>
        }
      </form>
    </Modal>
  }
}
const mapStateToProps = state => {
  return {
    currentUser: state.user.currentUser,
    product: state.products.product,
    region: state.shared.region,
    regions: state.shared.regions,
    highlightModal: state.shared.highlightModal,
    shBranchId: state.shared.shBranchId,
    locations: state.locations.estados,
    branches: state.shared.regionBranches,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...USER_ACTION,
      ...SHARED_ACTION,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalWhatsapp)



// WEBPACK FOOTER //
// ./src/components/children/contactForm/ModalWhatsapp.js